export enum USER_ROLE {
  GOD = 'GOD',
  SUPERADMIN = 'SUPERADMIN',
  ADMIN = 'ADMIN',
  USER = 'USER',
  TEST = 'TEST',
}
